import React from 'react';

export const AboutPage: React.FC = () => {
  return (
    <div>
      <div className="mb-8 text-center">
        <h1 className="text-3xl font-bold text-secondary mb-2">À propos du Fan Club Challenge</h1>
        <p className="text-lg text-gray-600">Découvrez tout sur notre plateforme de support des universités</p>
      </div>
      
      <div className="bg-white rounded-lg shadow-md p-6 mb-6">
        <h2 className="text-2xl font-bold text-secondary mb-4">Notre mission</h2>
        <p className="text-gray-600 mb-4">
          Le Fan Club Challenge est une plateforme innovante créée pour permettre aux étudiants, 
          alumni et sympathisants de montrer leur soutien à leur université préférée lors des jeux universitaires.
        </p>
        <p className="text-gray-600 mb-4">
          Notre objectif est de renforcer l'esprit de compétition amicale entre les universités camerounaises
          et de créer une communauté engagée autour des jeux universitaires.
        </p>
      </div>
      
      <div className="bg-white rounded-lg shadow-md p-6 mb-6">
        <h2 className="text-2xl font-bold text-secondary mb-4">Comment ça marche ?</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="text-center p-4">
            <div className="bg-primary text-tertiary w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4 text-xl font-bold">1</div>
            <h3 className="text-lg font-bold text-secondary mb-2">Inscrivez-vous</h3>
            <p className="text-gray-600">Créez votre compte en quelques secondes avec votre numéro de téléphone</p>
          </div>
          
          <div className="text-center p-4">
            <div className="bg-primary text-tertiary w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4 text-xl font-bold">2</div>
            <h3 className="text-lg font-bold text-secondary mb-2">Choisissez votre université</h3>
            <p className="text-gray-600">Parcourez la liste des universités participantes et sélectionnez celle que vous souhaitez supporter</p>
          </div>
          
          <div className="text-center p-4">
            <div className="bg-primary text-tertiary w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4 text-xl font-bold">3</div>
            <h3 className="text-lg font-bold text-secondary mb-2">Montrez votre soutien</h3>
            <p className="text-gray-600">Votez pour votre université et suivez son classement en temps réel</p>
          </div>
        </div>
      </div>
      
      <div className="bg-white rounded-lg shadow-md p-6 mb-6">
        <h2 className="text-2xl font-bold text-secondary mb-4">Règles du Challenge</h2>
        <ul className="list-disc pl-6 text-gray-600 space-y-2">
          <li>Chaque personne ne peut voter qu'une seule fois par édition des jeux universitaires</li>
          <li>Votre vote est définitif et ne peut pas être modifié une fois confirmé</li>
          <li>L'authentification par SMS garantit l'intégrité du processus de vote</li>
          <li>Le classement est mis à jour en temps réel en fonction du nombre de supporters</li>
          <li>Les résultats finaux seront annoncés lors de la cérémonie de clôture des jeux universitaires</li>
        </ul>
      </div>
      
      <div className="bg-white rounded-lg shadow-md p-6">
        <h2 className="text-2xl font-bold text-secondary mb-4">Contact</h2>
        <p className="text-gray-600 mb-4">
          Pour toute question ou suggestion concernant le Fan Club Challenge, n'hésitez pas à nous contacter :
        </p>
        <div className="flex flex-col md:flex-row md:space-x-8">
          <div className="mb-4 md:mb-0">
            <h3 className="text-lg font-bold text-secondary mb-2">Email</h3>
            <p className="text-gray-600">contact@fanclubchallenge.com</p>
          </div>
          <div className="mb-4 md:mb-0">
            <h3 className="text-lg font-bold text-secondary mb-2">Téléphone</h3>
            <p className="text-gray-600">+237 6XX XXX XXX</p>
          </div>
          <div>
            <h3 className="text-lg font-bold text-secondary mb-2">Réseaux sociaux</h3>
            <div className="flex space-x-4">
              <a href="#" className="text-secondary hover:text-primary">Facebook</a>
              <a href="#" className="text-secondary hover:text-primary">Twitter</a>
              <a href="#" className="text-secondary hover:text-primary">Instagram</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
